import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const PEND_STATUS = {
  enviado: { label: 'Por ler', cls: 'bg-amber-100 text-amber-800' },
  lido: { label: 'Lido · a decorrer 24h', cls: 'bg-sky-100 text-sky-800' },
  em_atraso: { label: 'Prazo terminado', cls: 'bg-rose-600 text-white' },
  pendente_resolucao: { label: 'Pendente de resolução', cls: 'bg-orange-500 text-white' },
  concluido: { label: 'Concluído', cls: 'bg-emerald-100 text-emerald-800' },
  cancelado: { label: 'Cancelado', cls: 'bg-slate-100 text-slate-500' },
};

export const OUTCOMES = {
  mudou: 'Cliente mudou / novo contrato',
  nao_quer: 'Cliente não quer mudar',
  sem_contacto: 'Impossível contactar',
  outro: 'Outro',
};

export const ACTION_LABEL = {
  enviado: 'Alerta enviado', lido: 'Lido', seguimento: 'Seguimento', justificado: 'Justificação (prazo ultrapassado)',
  concluido: 'Concluído', cancelado: 'Cancelado',
};

export const isManager = (user) => ['super_admin', 'gestor'].includes(user?.role);

export const fmtDT = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export const PendBadge = ({ status, testId }) => {
  const s = PEND_STATUS[status] || { label: status, cls: 'bg-slate-100' };
  return <span data-testid={testId} className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${s.cls}`}>{s.label}</span>;
};

const left = (deadline) => new Date(deadline).getTime() - Date.now();

export const Countdown = ({ deadline, testId }) => {
  const [ms, setMs] = useState(() => left(deadline));
  useEffect(() => {
    const t = setInterval(() => setMs(left(deadline)), 30000);
    return () => clearInterval(t);
  }, [deadline]);
  if (!deadline) return null;
  if (ms <= 0) return <span data-testid={testId} className="inline-flex items-center gap-1 text-xs font-bold text-rose-600"><Timer className="w-3.5 h-3.5" />Prazo terminado</span>;
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const cls = h < 4 ? 'text-rose-600' : h < 12 ? 'text-orange-600' : 'text-sky-700';
  return <span data-testid={testId} className={`inline-flex items-center gap-1 text-xs font-bold ${cls}`}><Timer className="w-3.5 h-3.5" />faltam {h}h {String(m).padStart(2, '0')}m</span>;
};
